import httpClient from "../utilities/httpClient"
import { setUserFields, startLoading, stopLoading } from "./general"

export const getUserFilterPresets = ({ onSuccess = () => { } } = {}) => async (dispatch) => {
    dispatch(startLoading())
    const { data: { payload: response } } = await httpClient.get(`/filter-presets`)
    onSuccess(response)
    dispatch(setUserFields({ filterPresets: response }))
    dispatch(stopLoading())
}
export const createUserFilterPreset = ({ payload = {}, onSuccess = () => { } } = {}) => async (dispatch) => {
    dispatch(startLoading())
    const { data: { payload: response } } = await httpClient.post(`/filter-presets`, payload)
    onSuccess(response)
    dispatch(getUserFilterPresets())
    dispatch(stopLoading())
}
export const applyUserFilterPreset = ({ payload = {}, onSuccess = () => { } } = {}) => async (dispatch) => {
    dispatch(startLoading())
    const { data: { payload: response } } = await httpClient.post(`/filter-presets/apply`, payload)
    onSuccess(response)
    dispatch(getUserFilterPresets())
    dispatch(stopLoading())
}
export const deleteUserFilterPreset = ({ payload = '', onSuccess = () => { } } = {}) => async (dispatch) => {
    dispatch(startLoading())
    const { data: { payload: response } } = await httpClient.delete(`/filter-presets/${payload}`)
    onSuccess(response)
    dispatch(getUserFilterPresets())
    dispatch(stopLoading())
}